import React from 'react';
import {
  DialogTitle,
  Typography,
  IconButton,
  useTheme,
  SxProps,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppRow } from './appRow';
import { ColorPalette } from '../styles/constants';

interface Props {
  title: string;
  handleClose(): void;
  sx?: SxProps;
}

export function AppDialogTitle({ title, handleClose, sx }: Props): JSX.Element {
  const theme = useTheme();

  return (
    <DialogTitle
      sx={{
        minWidth: '530px',
        background: `linear-gradient(152.32deg, ${theme.palette.primary.main} -1.72%, #1D3557 73.55%, #190E1F 99.47%)`,
        paddingTop: '20px',
        ...sx,

        [theme.breakpoints.down('sm')]: {
          minWidth: '325px',
        },
      }}
    >
      <AppRow sx={{ width: '100%' }}>
        <Typography sx={{ lineHeight: '0px' }} variant="subtitle1">
          {title}
        </Typography>
        <IconButton
          aria-label="close add activity dialog"
          onClick={handleClose}
          sx={{ p: 0 }}
        >
          <CloseIcon sx={{ color: ColorPalette.WHITE }} />
        </IconButton>
      </AppRow>
    </DialogTitle>
  );
}
